export const environment = {
    services: {
        IpService: 'https://api.ipify.org?format=json',
        SisDenuncia: 'https://denunciaenlineaapi.sunedu.gob.pe/api/',
    },
    recaptcha_v3_site_key: '6LcZ8PsqAAAAAHkwFpCe8SwQ30_evBg1TSOavPhR',
    production: true,
    development: false,
    enableBaseServiceLogs: true,
    encryptation: {
        enabled: true,
        key: '484060556f8744ab799c69961bc5a6c190f22097',
        excluded: [],
    },
    timeoutminuser: 15,
    gaMeasurementId: 'G-YT037D1755',
    turnstile_site_key: '0x4AAAAAACC8CyDMlL73bL6k'
};
